import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IItemTreeview } from '../typings/IItemTreeview';
import { ObjectType } from '../typings/ObjectType';
import { I18nService } from 'i18n/i18n.service';

@Component({
  selector: 'app-processes-tree-view-node',
  templateUrl: './processes-tree-view-node.component.html',
  styleUrls: ['./processes-tree-view-node.component.scss']
})
export class ProcessesTreeViewNodeComponent {
  @Input() isLast: boolean = false;
  @Input() node!: IItemTreeview;
  @Input() value?: IItemTreeview;
  @Output() selectedNode = new EventEmitter<IItemTreeview>();
  @Output() nodeToggled = new EventEmitter<IItemTreeview>();

  constructor(private _i18nService: I18nService) {}

  toggle() {
    this.node.isExpanded = !this.node.isExpanded;
  }

  selectNode() {
    this.selectedNode.emit(this.node);
  }

  emitNode() {
    this.nodeToggled.emit(this.node);
  }

  haveChildren(): boolean {
    return Array.isArray(this.node.nodes) && this.node.nodes.length > 0;
  }

  hasVisibleChild(): boolean {
    return Array.isArray(this.node.nodes) && this.node.nodes.length > 1;
  }

  shouldDisplayInSticky(): boolean {
    return this.node.type === ObjectType.ROOT || this.node.type === ObjectType.CATEGORY;
  }

  handleNodeClick() {
    this.selectNode();
    if (this.haveChildren()) {
      this.toggle();
    }
  }

  getNodeTypeIcon(node: IItemTreeview): string {
    switch (node.type) {
      case ObjectType.ROOT: return 'biz-icon';
      case ObjectType.CATEGORY: return 'folder';
      case ObjectType.PROCESS: return 'diagram';
      case ObjectType.VERSION: return 'timer';
      case ObjectType.ACTIVITY: return 'activity';
      case ObjectType.SUBPROCESS: return 'process';
      case ObjectType.REUSABLE_GROUP: return 'reusable';
      case ObjectType.EMBEDDED_GROUP: return 'embedded';
      default: return 'diagram';
    }
  }

  get displayNodeName(): string {
    if (this.node.type === ObjectType.VERSION) {
      return `${this._i18nService.instant('AIFORPROCESSES.OBJECTTYPE.VERSION')} ${this.node.displayName}`;
    }
    return this.node.displayName;
  }
}
